module.exports = __webpack_public_path__ + "static/img/gxd@2x.16e93fe0.png";